import { Modality } from 'types';

const MODALITIES_WITH_LANDING_PAGE = [Modality.Course];

export default MODALITIES_WITH_LANDING_PAGE;
